<div class="title-header">
    <label>Detalle</label>
</div>
<div class="information-detail" fxLayout="row" fxLayoutAlign="space-between stretch">
    <div fxFlex="35%">
        <label>Información proveedor</label>
        <div class="fila">
            <p class="title" fxFlex="48%">Razón social:</p>
            <p fxFlex="48%">{{ detalleFact.RazonSocialProveedor }}</p>
        </div>
        <div>
            <p class="title" fxFlex="48%">Rut:</p>
            <p fxFlex="48%">{{ detalleFact.RutProveedor | formatearRut}}</p>
        </div>
        <div *ngIf="ocultarInfo">
            <p class="title" fxFlex="48%">Nombre:</p>
            <p fxFlex="48%">{{ detalleFact.NombreProveedor }}</p>
        </div>
        <div *ngIf="ocultarInfo">
            <p class="title" fxFlex="48%">Sucursal:</p>
            <p fxFlex="48%">{{ detalleFact.Sucursal }}</p>
        </div>
        <div *ngIf="ocultarInfo" class="subtittle-secundary">
            <label >Información del comprador</label>
            <div class="fila">
                <p class="title" fxFlex="48%">Folio:</p>
                <p fxFlex="48%">{{ detalleFact.Folio }}</p>
            </div>
            <div>
                <p class="title" fxFlex="48%">Centro gestión:</p>
                <p fxFlex="48%">{{ detalleFact.CentroGestion }}</p>
            </div>
            <div>
                <p class="title" fxFlex="48%">Razón social:</p>
                <p fxFlex="48%">{{ detalleFact.RazonSocial }}</p>
            </div>
            <div>
                <p class="title" fxFlex="48%">Forma de pago:</p>
                <p fxFlex="48%">{{ detalleFact.FormaPago }}</p>
            </div>
        </div>
    </div>
    <div fxFlex="65%" class="separador">
        <label>Información factura</label>
        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex="48%">
                <div class="fila">
                    <p class="title" fxFlex="48%">Emisión:</p>
                    <p fxFlex="48%">{{ detalleFact.FechaEmision | formatearFecha }}</p>
                </div>
                <div>
                    <p class="title" fxFlex="48%">Pago estimado:</p>
                    <p fxFlex="48%">{{ detalleFact.FechaEstimaPago | formatearFecha  }}</p>
                </div>
                <div *ngIf="ocultarInfo">
                    <p class="title" fxFlex="48%">Vencimiento estimado:</p>
                    <p fxFlex="48%">{{ detalleFact.FechaVencimiento | formatearFecha}}</p>
                </div>
                <div *ngIf="ocultarInfo">
                    <p class="title" fxFlex="48%">Folio único:</p>
                    <p fxFlex="48%">{{ detalleFact.FolioUnico }}</p>
                </div>
                <div *ngIf="ocultarInfo">
                    <p class="title" fxFlex="48%">Recepción:</p>
                    <p fxFlex="48%">{{ detalleFact.FechaRecepcion | formatearFecha}}</p>
                </div>
                <div *ngIf="ocultarInfo">
                    <p class="title" fxFlex="48%">Recepción SII:</p>
                    <p fxFlex="48%">{{ detalleFact.FechaRecepcionSII | formatearFecha}}</p>
                </div>
            </div>
            <div fxFlex="48%" class="content-last-info">
                <div *ngIf="ocultarInfo" class="table-value">
                    <div class="content-table-value">
                        <div>
                            <p class="title" fxFlex="46%">Tipo cambio facturado:</p>
                            <p class="descripcion" fxFlex="46%">{{detalleFact.TasaCambio | formatearNumero }} {{ detalleFact.DescripcionMoneda}}</p>
                        </div>
                        <div>
                            <p class="title" fxFlex="46%">Total Neto (Afecto) ({{monedaLocal}}):</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoNeto | formatearNumero }}</p>
                        </div>
                        <div>
                            <p class="title" fxFlex="46%">Monto Exento ({{monedaLocal}}):</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoNetoNoAfecto | formatearNumero}}</p>
                        </div>
                        <div class="line-top">
                            <p class="title" fxFlex="46%">IVA:</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoIva | formatearNumero}}</p>
                            <span fxFlex="8%" (click)="showDetailIva()"> <fa-icon [icon]="iconIva"></fa-icon> </span>
                        </div>
                        <div class="line-top sub-cell" *ngIf="showDataIva">
                            <p class="title" fxFlex="46%">IVA Recuperable:</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoIvaRecuperable| formatearNumero}}</p>
                        </div>
                        <div class="line-top sub-cell" *ngIf="showDataIva">
                            <p class="title" fxFlex="46%">IVA No Recuperable:</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoIvaNoRecuperable| formatearNumero}}</p>
                        </div>
                        <div class="line-top">
                            <p class="title" fxFlex="46%">Crédito Especial 65%:</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoCredEc | formatearNumero}}</p>
                        </div>
                        <div class="line-top">
                            <p class="title margin-bottom-none" fxFlex="46%">Otros impuestos y retenciones:</p>
                            <p class="descripcion margin-bottom-none" fxFlex="46%">${{detalleFact.MontoOtrosImpuestos | formatearNumero}}</p>
                            <span fxFlex="8%" (click)="showDetailImpuestos()"> <fa-icon [icon]="iconImpuesto"></fa-icon> </span>
                        </div>
                        <div class="line-top sub-cell" *ngIf="showDataImpuesto">
                            <p class="title" fxFlex="46%">Recuperable:</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoOtroImpuestoRecupetable | formatearNumero}}</p>
                        </div>
                        <div class="line-top sub-cell" *ngIf="showDataImpuesto">
                            <p class="title" fxFlex="46%">No Recuperable:</p>
                            <p class="descripcion" fxFlex="46%">${{detalleFact.MontoOtroImpuestoNoRecupetable | formatearNumero}}</p>
                        </div>
                    </div>
                    <div class="content-table-total">
                        <div>
                            <p class="title" fxFlex="46%"><b>Total ({{monedaLocal}}):</b></p>
                            <p class="descripcion" fxFlex="46%"><b>${{detalleFact.TotalFactura | formatearNumero}}</b></p>
                        </div>
                    </div>
                </div>
                <div class="content-more-detail">
                    <div class="separador-action">
                        <a (click)="acordeon()">{{ ocultarInfo ? 'Ver menos' : 'Más detalle' }}
                        </a>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>